import World from '../components/3DGlobe/3DGlobe'

const LandingPage = () => {
    return (
        <div>
            <World />
        </div>
    )
}

export default LandingPage;


